/**
 * While not a constant, this will be used to return default locale.
 * Supports anonymous users' browser locales.
 */
export const getBrowserDefaultLocale = () => {
  return globalThis.navigator?.languages?.[0] ?? 'en-US';
};
